import React, { useState, useRef, useEffect } from "react";
import { IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/MegaMenu";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "owl.carousel"; // Import Owl Carousel AFTER jQuery
import OwlCarousel from "react-owl-carousel";
import "../outterpages.css";
import curreciesBan from "../../../assets/Images/Outterpage/currencies-banner-img.webp";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Stack from "@mui/material/Stack";
import eng from "../../../assets/Images/Outterpage/eng.webp";
import jap from "../../../assets/Images/Outterpage/jap.webp";
import cardimg from "../../../assets/Images/Outterpage/card-1.webp";
import sec4 from "../../../assets/Images/Outterpage/sec-4-img.webp";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderBottom: "1px solid  rgba(255, 146, 71, 1)  ",
  "&:nth-of-type(odd)": {
    background:
      "linear-gradient(90deg,rgba(99, 97, 97, 0.44) 15.1%,rgba(70, 69, 68, 0.49) 85.42%)",
  },
  // Hide the last border of the table
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// const videos = [
//   { id: 1, src: video1 },
//   { id: 2, src: video2 },
//   { id: 3, src: video3 },
//   { id: 3, src: video4 },
// ];
const testimonials = [
  {
    name: "Sherly",
    position: "CEO",
    text: "Figma ipsum component variant main layer. Library figjam subtract font rotate move auto. Figjam strikethrough bullet text device pen scale. Group horizontal link library flows ellipse flatten library undo.",
  },
  {
    name: "Carlos",
    position: "Product Manager",
    text: "An amazing experience! The support and innovation mindset Rishi brings to the team makes every project more exciting and successful.",
  },
  // {
  //   name: "Rishi",
  //   position: "CEO",
  //   text: "Regulus has truly streamlined my trading activity. The platform is incredibly user-friendly, making it easy to navigate and execute trades quickly. I've seen a noticeable improvement in my efficiency!",
  // },
];

const options = {
  margin: 50,
  items: 1,
  autoplay: true,
  autoplayTimeout: 6000,
  dots: false, // Hide default dots
  loop: true,
  smartSpeed: 800,
  nav: true, // We will use custom navigation
  responsive: {
    0: {
      dots: true,
      nav: false,
    },
    768: {
      dots: false,
      nav: true,
    },
  },
};

const marketData = [
  { id: 1, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 2, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 3, pair: "GBP/USD", value: "1,120.65", trend: "down" },
  { id: 4, pair: "GBP/USD", value: "1,355.78", trend: "up" },
  { id: 5, pair: "GBP/USD", value: "1,120.65", trend: "down" },
];

const tableData = [
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
  {
    name: "USDJPY",
    speed: "83.4",
    comission: "$0",
    margin: "0.34%,",
    longswap: "-44",
    shortswap: "-44",
    stoplevel: "0",
  },
];
const accordianData = [
  {
    question: "What is Finowiz?",
    answer:
      "At Finowiz, you don’t just trade – you feel empowered. As a forward-thinking forex brokerage, we blend innovation, insight, and integrity to help traders of all levels navigate global markets with confidence. With cutting-edge tools and expert support, Finowiz is where smart trading begins, and success becomes a habit.",
    panel: "panel1",
  },
  {
    panel: "panel2",
    question: "How do I register?",
    answer: "Follow the steps below:",
    listItems: [
      <>
        Visit{" "}
        <Link style={{ color: "#0064ff", wordWrap: 'break-word' }} to="#">
          https://www.finowizprime.com#
        </Link>{" "}
        and complete the registration
      </>,
      "Email verify your account",
      "Submit necessary KYC documents for account verification.",
      "Once approved, you can create and fund your account and start trading",
    ],
  },
  {
    panel: "panel3",
    question: "What types of accounts does Finowiz offer?",
    answer:
      "Finowiz offers various account types to cater to different trading needs:",
    listItems: [
      "Micro Account : Ideal for beginners, offering competitive spreads and no commissions.",
      "Standard Account : Offer a better environment with even tighter spreads without any commission, Ideal for intermediate level traders",
      "ECN Account : Designed for experienced traders, providing raw spreads with a small commission per trade.",
    ],
  },

  {
    panel: "panel4",
    question: "What trading platforms are available?",
    answer:
      "We support the industry-leading MetaTrader 5 (MT5) platforms, accessible on desktop, web, and mobile devices, ensuring you can trade anytime, anywhere.",
  },
  {
    panel: "panel5",
    question: "What instruments can I trade with Finowiz?",
    answer:
      "Our platform offers a diverse range of trading instruments, including:",
    listItems: [
      "Forex : Major, minor, and exotic currency pairs.",
      "Commodities : Gold, silver, oil, and more.",
      "Indices : Global indices like S\&P 500, NASDAQ, FTSE 100 and more",
      "Cryptocurrencies : Bitcoin, Ethereum, and other popular digital currencies.",
    ],
  },
  {
    panel: "panel6",
    question: "What are the deposit and withdrawal methods?",
    answer:
      "Finowiz supports multiple payment methods for deposits and withdrawals:",
    listItems: [
      "Crypto Deposits",
      "Bank wire transfers",
      "Credit/debit cards",
      "Please note that processing times and fees may vary depending on the chosen method.",
    ],
  },
  {
    panel: "panel7",
    question: "Is there a minimum deposit requirement?",
    answer: "Yes, the minimum deposit varies based on the account type:",
    listItems: [
      "Micro Account : 50$",
      "Standard Account : $1000",
      "ECN Account : $2500",
      "These amounts ensure that traders have sufficient capital to manage their positions effectively.",
    ],
  },
  {
    panel: "panel8",
    question: "How does Finowiz ensure the safety of client funds?",
    answer:
      "Client fund security is paramount at Finowiz. We implement the following measures:",
    listItems: [
      "Segregated Accounts : Client funds are held separately from the company's operational funds.",
      "Regulatory Compliance : We adhere to strict regulatory standards and undergo regular audits.",
      "Advanced Security Protocols : Our platforms use encryption and other security measures to protect client data and transactions.",
    ],
  },
  {
    panel: "panel9",
    question: "Does Finowiz offer educational resources?",
    answer:
      "Absolutely! We provide a comprehensive suite of educational materials, including:",
    listItems: [
      "Webinars and seminars : Led by industry experts.",
      "Tutorials and guides : Covering various trading topics.",
      "Market analysis : Daily and weekly insights to inform your trading decisions.",
    ],
  },
  {
    panel: "panel10",
    question: "What support does Finowiz offer to Introducing Brokers (IBs)?",
    answer: "Finowiz values its IB partners and offers:",
    listItems: [
      <>
        <b>Attractive Commission Structures -</b> High and flexible payouts to
        maximize IB earnings.
      </>,
      <>
        <b>Multi-Tier Referral Program -</b> Earn from direct and sub-IBs for
        scalable passive income.
      </>,
      <>
        <b>Real-Time Tracking &amp; Reporting Tools -</b> Transparent dashboards
        for client tracking, performance analytics, and commissions.
      </>,
      <>
        <b>Personalized Account Management -</b> Dedicated relationship managers
        to support and grow your network.
      </>,
      <>
        <b>Fast &amp; Reliable Payouts -</b> Timely weekly or monthly payments
        via preferred methods.
      </>,
      <>
        <b>Marketing &amp; Branding Support -</b> Co-branded materials, digital
        assets, and campaign support to enhance IB outreach..
      </>,
      <>
        <b>Comprehensive Training &amp; Education -</b> Regular webinars and
        resources to upskill IBs and educate their clients.
      </>,
      <>
        <b>Regulated &amp; Trusted Brokerage Platform -</b> Operate under a
        compliant and transparent trading environment.
      </>,
      <>
        <b>Multi-Asset Trading Access -</b> Access to FX, commodities, indices,
        and crypto to attract diverse clients.
      </>,
    ],
  },
];

const FAQ = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const md900 = useMediaQuery(theme.breakpoints.up("900"));
  const md700 = useMediaQuery(theme.breakpoints.up("700"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const [expanded, setExpanded] = React.useState("panel1");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <div className="OutterPage">
      <Header />

      <section className="trade-easy faq sec-3 ">
        <div className="contain-width">
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <div className="heading">
                <p>TRADE CURRENCIES ON THE GLOBAL FINANCIAL MARKET</p>
                <h2>
                  Experience Superior Online Forex Trading with{" "}
                  <span>Finowiz</span>
                </h2>
                <p>
                  Forex trading, also known as foreign exchange trading,
                  involves exchanging one currency for another in the global
                  market. At Finowiz, traders can take advantage of market
                  fluctuations by purchasing currencies at lower prices and
                  selling them at higher prices to maximize their profits.
                </p>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="faq faq-outter-bg ">
        <div className="contain-width">
          <Grid
            container
            spacing={8}
            sx={{ rowGap: 0, marginBottom: md700 && "50px" }}
          >
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="left-side  mb-50"
            >
              {accordianData.map((item, index) => (
                <Accordion
                  key={item.panel || index} // fallback to index if panel is undefined
                  className="accordion"
                  expanded={expanded === item.panel}
                  onChange={handleChange(item.panel)}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <h3>{item.question}</h3>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>{item.answer}</p>
                    {item.listItems && item.listItems.length > 0 && (
                      <ul style={{ marginLeft: "30px" }} className="mt-10">
                        {item.listItems.map((listItem, i) => (
                          <li style={{padding:'5px'}} key={i}>{listItem}</li>
                        ))}
                      </ul>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </Grid>
          </Grid>
        </div>
      </section>

      <section class="cta-sec2 out-cta">
        <div className="contain-width">
          <Grid container spacing={8}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <label>Your Partner in Trading Success</label>
              <h2>Register Now for Seamless Trading with Finowiz</h2>
              <Link to="#" className="brd-btn">
                Register Now
              </Link>
            </Grid>
          </Grid>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;
